import {
  GAME_VOD_EXTENSION,
  MAX_FILE_SIZE,
  SUPPORTED_FILE_TYPE,
  FILE_TYPE,
} from "./vod.constants"

export const checkFileType = (file, gameKey) => {
  if (file.type && !SUPPORTED_FILE_TYPE.includes(file.type)) {
    return false
  }
  // check if file is in special type
  if (!file.type) {
    const extension = file.name.split(".").pop()
    if (!GAME_VOD_EXTENSION[gameKey].includes(extension)) {
      return false
    }
  }
  return true
}

export const checkFileSize = file => {
  if (file.size >= MAX_FILE_SIZE) {
    return false
  }
  return true
}

export const getReadableBytes = bytes => {
  const i = Math.floor(Math.log(bytes) / Math.log(1024))
  const sizes = ["B", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
  return (bytes / Math.pow(1024, i)).toFixed(2) * 1 + " " + sizes[i]
}

export const getFileExtensionForUploading = file => {
  const extension = file.name.split(".").pop()
  return extension
}

export const getFileTypeName = fileType => {
  switch (fileType) {
    case FILE_TYPE.QUICKTIME:
      return ".MOV"
    case FILE_TYPE.MP4:
      return ".MP4"
    case FILE_TYPE.ROFL:
      return ".ROFL"
    case FILE_TYPE.REPLAY:
      return ".REPLAY"
    default:
      return ""
  }
}

export const getGameSupportedFileType = game => {
  return GAME_VOD_EXTENSION[game] || []
}



// WEBPACK FOOTER //
// ./src/store/vod/vod.utils.js